<template>
  <v-row dense>
    <v-col
      v-for="group in visibleGroups"
      :key="group.key"
      cols="12"
      md="6"
      lg="4"
    >
      <v-card
        outlined
        class="fill-height"
        :class="{ 'danger-group': group.danger }"
      >
        <v-card-title class="py-2 subtitle-1">
          <v-checkbox
            :input-value="groupState(group) === 'all'"
            :indeterminate="groupState(group) === 'some'"
            :disabled="disabled"
            :color="group.danger ? 'error' : 'primary'"
            hide-details
            class="mt-0 pt-0"
            @change="toggleGroup(group, $event)"
          />
          <v-icon
            small
            class="mr-1"
            :color="group.danger ? 'error' : ''"
          >
            {{ group.icon }}
          </v-icon>
          <span class="font-weight-bold">{{ group.label }}</span>
          <v-spacer />
          <span class="caption grey--text">
            {{ countIn(group) }}/{{ group.items.length }}
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-1 pb-2">
          <div
            v-for="item in group.items"
            :key="item.name"
            class="d-flex align-center"
          >
            <v-checkbox
              :input-value="value.includes(item.name)"
              :disabled="disabled"
              :color="group.danger ? 'error' : 'primary'"
              hide-details
              dense
              class="mt-0 pt-1"
              @change="toggle(item.name, $event)"
            >
              <template v-slot:label>
                <div>
                  <div class="body-2 black--text">
                    {{ item.label }}
                    <v-chip
                      v-if="isAdded(item.name)"
                      x-small
                      color="success"
                      class="ml-1"
                    >
                      ເພີ່ມ
                    </v-chip>
                    <v-chip
                      v-if="isRemoved(item.name)"
                      x-small
                      color="error"
                      class="ml-1"
                    >
                      ຖອນ
                    </v-chip>
                  </div>
                  <div class="caption grey--text">
                    {{ item.name }}
                    <span
                      v-if="inherited[item.name]"
                      class="info--text"
                    >
                      · ມີແລ້ວຈາກ role {{ inherited[item.name].join(', ') }}
                    </span>
                  </div>
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      v-if="!visibleGroups.length"
      cols="12"
      class="text-center grey--text"
    >
      ບໍ່ພົບ permission ທີ່ຄົ້ນຫາ
    </v-col>
  </v-row>
</template>

<script>
import { groupPermissions } from './permissionCatalog';

// Permissions grouped by area, a tick-all checkbox per group. v-model is the array of
// ticked permission names; `original` marks what changed; `inherited` notes permissions
// a user already has through a role ({ name: [role names] }).
export default {
  name: 'PermissionGroupPicker',
  props: {
    value: { type: Array, default: () => [] },
    names: { type: Array, default: () => [] },
    original: { type: Array, default: () => [] },
    inherited: { type: Object, default: () => ({}) },
    search: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    groups() {
      return groupPermissions(this.names);
    },
    visibleGroups() {
      const term = (this.search || '').trim().toLowerCase();
      if (!term) return this.groups;
      return this.groups
        .map((group) => (group.label.toLowerCase().includes(term)
          ? group
          : {
            ...group,
            items: group.items.filter((item) => item.name.toLowerCase().includes(term)
              || item.label.toLowerCase().includes(term)),
          }))
        .filter((group) => group.items.length);
    },
  },
  methods: {
    isAdded(name) {
      return this.value.includes(name) && !this.original.includes(name);
    },
    isRemoved(name) {
      return !this.value.includes(name) && this.original.includes(name);
    },
    countIn(group) {
      return group.items.filter((item) => this.value.includes(item.name)).length;
    },
    groupState(group) {
      const count = this.countIn(group);
      if (!count) return 'none';
      return count === group.items.length ? 'all' : 'some';
    },
    toggle(name, checked) {
      this.$emit('input', checked
        ? [...this.value, name]
        : this.value.filter((selected) => selected !== name));
    },
    // Ticks or clears every permission of the group (only those shown, when searching).
    toggleGroup(group, checked) {
      const names = group.items.map((item) => item.name);
      this.$emit('input', checked
        ? [...new Set([...this.value, ...names])]
        : this.value.filter((name) => !names.includes(name)));
    },
  },
};
</script>

<style scoped>
.danger-group {
  border-color: #ef5350 !important;
}
</style>
